import { RoleModel } from "models";
import { apiMiddleware } from "../api.middleware";

export const getRoles = apiMiddleware<RoleModel[]>()({
  method: "get",
  endpoint: "/job/list",
});
